import { useState, useEffect } from 'react'
import * as Util from '../data/General';

const timer = 10200;
const countPage = 30;
export function useMessagesSelected ({ callback = null, idMessage, body = null, method="POST", server="inboxs/conversations"}) {
  const [data, setData] = useState(null);
  const [id, setId] = useState(idMessage);
  const [url, setURL] = useState(`/${idMessage}/messages`);
  const [isLoad, setIsLoad] = useState(false);
  const [count, setCount] = useState(countPage);
  
  const refreshUrl = (t, c) => {
    if(t === ""){
      setURL(`?from=0&size=${c}&sortBy=updated_at&sortOrder=desc`);
    }else{
      setURL(`/messages?text=${t}&from=0&size=${c}&sortBy=updated_at&sortOrder=desc`);
    }
  }

  const refreshId = (i) => {
    setId(i);
    setURL(`/${i}/messages`);
  }

  const incrementPage = (add=countPage) => {
    setCount(count + add);
    refreshUrl("", count + add);
  }

  const refreshData = () => {
    if(url !== ""){
      setIsLoad(true);
      clearTimeout(window.intervalMessageSelected); 
      Util.callServer(dataOk, dataFail, `${server}${url}`,body, method);
    }
  }
  const dataOk = (data) => {
    setData(data);
    if(callback) {
      callback(data);
    }
    setIsLoad(false);
    window.intervalMessageSelected = setTimeout(function(){refreshData();}.bind(this), timer); 
  }
  const dataFail = (data) => {
    console.log(data);
  }
  
  // para recuperar la cita al cargar la página
  useEffect(() => {
    refreshData()
  }, [url])


  const clear = () => {
    clearTimeout(window.intervalMessageSelected);  
    setURL("");
  }

  const sendMessageWhatsapp = (message) => {
    const trimmed = message.trim();
    if (trimmed === "") return; // no enviar si está vacío
    const body = { body: trimmed };
    Util.callServer(dataOkSend, dataFail, `inboxs/conversations/${id}/messages`,body, "POST");
  }
  const dataOkSend = (data) => {
    refreshData()
  }

  return { data, isLoad, incrementPage, clear, sendMessageWhatsapp, refreshId }
}